// components/CarouselCard.tsx
import React, { useEffect, useRef, useState } from "react";

interface Slide {
  title: string;
  description: string;
  icon?: string; // optional icon path
}

interface CarouselCardProps {
  slides: Slide[];
  autoSlide?: boolean;
  interval?: number;
}

const CarouselCard: React.FC<CarouselCardProps> = ({
  slides,
  autoSlide = true,
  interval = 4000,
}) => {
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!autoSlide) return;

    const id = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, interval);

    return () => clearInterval(id);
  }, [autoSlide, interval, slides.length]);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.style.transform = `translateX(-${currentIndex * 100}%)`;
    }
  }, [currentIndex]);

  return (
    <div className="hidden lg:block absolute bottom-10 left-1/2 -translate-x-1/2 z-20 w-[85%] overflow-hidden">
      <div
        ref={carouselRef}
        className="flex transition-transform duration-700 ease-in-out"
      >
        {slides.map((slide, idx) => (
          <div
            key={idx}
            className="w-full shrink-0 p-8 border border-white/30 rounded-lg backdrop-blur-md bg-white/10"
          >
            <div className="w-10 h-10 bg-white rounded-md mb-4 flex items-center justify-center">
              <img
                src={slide.icon || "../../logo.svg"}
                alt="Slide Icon"
                className="w-6 h-6"
              />
            </div>
            <h2 className="text-white text-lg font-semibold text-left">
              {slide.title}
            </h2>
            <p className="text-white text-sm mt-1 text-left">
              {slide.description}
            </p>
            {/* Dot Indicator */}
            <div className="flex space-x-1 mt-4 justify-left">
                {slides.map((_, i) => (
                <span
                    key={i}
                    className={`w-2 h-2 rounded-full ${
                    currentIndex === i ? "bg-white opacity-70" : "bg-white/30"
                    }`}
                />
                ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarouselCard;
